"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
var storage;
var baseURL;
// Check if running in a browser environment
var isBrowser = typeof window !== "undefined";
if (isBrowser) {
    storage = {
        getItem: function (key) { return Promise.resolve(localStorage.getItem(key)); },
        setItem: function (key, value) {
            return Promise.resolve(localStorage.setItem(key, value));
        },
        removeItem: function (key) { return Promise.resolve(localStorage.removeItem(key)); },
    };
    baseURL = process.env.REACT_APP_API_URL;
}
else {
    storage = async_storage_1.default;
    // android: 'http://10.0.2.2:5000' - ios: 'http://127.0.0.1:5000'
    baseURL = "http://127.0.0.1:5000";
}
var client = axios_1.default.create({
    baseURL: baseURL,
});
client.interceptors.request.use(function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, storage.getItem("token")];
            case 1:
                token = _a.sent();
                if (token) {
                    config.headers = config.headers || {};
                    config.headers.Authorization = "Bearer ".concat(token);
                }
                return [2 /*return*/, config];
        }
    });
}); }, function (error) { return Promise.reject(error); });
client.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                if (!(((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401)) return [3 /*break*/, 2];
                return [4 /*yield*/, storage.removeItem("token")];
            case 1:
                _e.sent();
                if (isBrowser) {
                    // Web navigation
                    window.location.href = "/login";
                }
                _e.label = 2;
            case 2:
                if (!(((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) === 422 &&
                    ((_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.msg) ===
                        "Signature verification failed")) return [3 /*break*/, 4];
                return [4 /*yield*/, storage.removeItem("token")];
            case 3:
                _e.sent();
                if (isBrowser) {
                    // Web navigation
                    window.location.href = "/login";
                }
                _e.label = 4;
            case 4: return [2 /*return*/, Promise.reject(error)];
        }
    });
}); });
exports.default = client;
